import * as Types from '../../generated/types';

import gql from 'graphql-tag';
import { CustomerContextApplicationSummaryFragmentDoc, CustomerContextCustomerFragmentDoc } from '../customer/CustomerContext.generated';
import { CurrentUserContextUserFragmentDoc } from '../current-user/CurrentUserContext.generated';
import * as Urql from '@/urql/urqlWrapper';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type IYesAuthedAppContextProviderQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type IYesAuthedAppContextProviderQuery = { __typename?: 'Query', getApplications: { __typename?: 'GetApplicationsResponse', applications: Array<{ __typename?: 'ApplicationSummary', id: string, status: Types.IApplicationStatus, legalName: string, dbaName?: string | null }> }, getCurrentUserCustomers: { __typename?: 'GetCurrentUserCustomersResponse', customers: Array<{ __typename?: 'Customer', id: string, name: string, status: Types.ICustomerStatus, usesPaymentReleaseStep: boolean, products: Array<Types.IProduct> }> } };

export type IYesAuthedCustomerAppContextProviderQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type IYesAuthedCustomerAppContextProviderQuery = { __typename?: 'Query', getActiveFeatures: Array<Types.IFeatureFlag>, getCurrentUser: { __typename?: 'UserResponse', user?: { __typename?: 'User', id: string, inactive: boolean, firstName: string, lastName: string, recipientId?: string | null, restrictedDetails?: { __typename?: 'UserRestrictedDetails', email: string, rolesInfo?: { __typename?: 'UserRolesInfo', role?: Types.IUserRole | null } | null } | null } | null }, getUserPermissions: { __typename?: 'PermissionsResponse', permissions: Array<string> } };

export type INonAuthedAppContextProviderQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type INonAuthedAppContextProviderQuery = { __typename?: 'Query', getActiveFeatures: Array<Types.IFeatureFlag> };


export const YesAuthedAppContextProviderDocument = gql`
    query YesAuthedAppContextProvider {
  getApplications {
    applications {
      ...CustomerContextApplicationSummary
    }
  }
  getCurrentUserCustomers {
    customers {
      ...CustomerContextCustomer
    }
  }
}
    ${CustomerContextApplicationSummaryFragmentDoc}
${CustomerContextCustomerFragmentDoc}`;

export function useYesAuthedAppContextProviderQuery(options?: Omit<Urql.UseQueryArgs<IYesAuthedAppContextProviderQueryVariables>, 'query'>) {
  return Urql.useQuery<IYesAuthedAppContextProviderQuery, IYesAuthedAppContextProviderQueryVariables>({ query: YesAuthedAppContextProviderDocument, ...options });
};
export const YesAuthedCustomerAppContextProviderDocument = gql`
    query YesAuthedCustomerAppContextProvider {
  getCurrentUser {
    user {
      ...CurrentUserContextUser
      restrictedDetails {
        rolesInfo {
          role
        }
      }
    }
  }
  getUserPermissions {
    permissions
  }
  getActiveFeatures
}
    ${CurrentUserContextUserFragmentDoc}`;

export function useYesAuthedCustomerAppContextProviderQuery(options?: Omit<Urql.UseQueryArgs<IYesAuthedCustomerAppContextProviderQueryVariables>, 'query'>) {
  return Urql.useQuery<IYesAuthedCustomerAppContextProviderQuery, IYesAuthedCustomerAppContextProviderQueryVariables>({ query: YesAuthedCustomerAppContextProviderDocument, ...options });
};
export const NonAuthedAppContextProviderDocument = gql`
    query NonAuthedAppContextProvider {
  getActiveFeatures
}
    `;

export function useNonAuthedAppContextProviderQuery(options?: Omit<Urql.UseQueryArgs<INonAuthedAppContextProviderQueryVariables>, 'query'>) {
  return Urql.useQuery<INonAuthedAppContextProviderQuery, INonAuthedAppContextProviderQueryVariables>({ query: NonAuthedAppContextProviderDocument, ...options });
};